import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';

import { Props } from './interface';
import { theme } from '../../resources/theme';
import UserRefund from '../../containers/UserRefund';
import { useDispatch, useSelector } from 'react-redux';
import { getSubscriptionAsync, selectSubscriptions } from '../../redux/slices/subscriptionSlice';
import { useEffect, useMemo } from 'react';
// import { Subscription } from '../../resources/types/balanceTypes';

const styles = {
  text: {
    color: theme.palette.info.main,
    fontWeight: 700
  }
};

export const ContractRefundModal = (props: Props) => {
  const {
    contract,
    tripCity,
    ...restProps
  } = props;

  const opened = restProps['open'];

  const dispatch = useDispatch();

  const { subscriptions } = useSelector(selectSubscriptions);

  useEffect(() => {
    if (opened && contract && !subscriptions.items.length) {
      dispatch(getSubscriptionAsync(tripCity ?? ''));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened, tripCity]);

  const userSubscriptions = useMemo(() => {
    if (!contract?.subscriptionPlan?.length) {
      return null;
    }

    const subscription = subscriptions.items.find(
      (s) => contract?.subscriptionPlan?.includes?.(s._id as string)
    )

    if (subscription) {
      return subscription;
    }

    // return subscriptions.items.filter((s) => contract?.subscriptionPlan?.includes?.(s._id as string))
    return null
  }, [contract?.subscriptionPlan, subscriptions.items])

  const cost = useMemo(() => {
    return contract?.sum;
  }, [contract?.sum]);

  if (!contract) {
    return null;
  }

  // console.log('-=-=-subscriptions', subscriptions);
  // console.log('-=-=- ContractRefundModal', JSON.stringify({ contract, userSubscriptions }, null, 4))

  return (
    <Dialog {...restProps}>
      <DialogTitle>Повернення коштів з поїздки</DialogTitle>
      <DialogContent>
        <Stack spacing={3} minWidth={450}>
          <Stack direction='column' spacing={2}>
            <Stack direction='row' alignItems='center' spacing={2}>
              <Typography marginBottom={0}>Вартість поїздки:</Typography>
              <Typography sx={styles.text} marginBottom={0}>
                {cost ? `${cost} грн` : 'Не вказано'}
              </Typography>
            </Stack>
            {
              userSubscriptions ? (

                <Stack direction='row' alignItems='center' spacing={2}>
                  <Typography marginBottom={0}>Абонемент:</Typography>
                  <Typography sx={styles.text} marginBottom={0}>
                    {userSubscriptions.name}
                  </Typography>
                </Stack>

              ) : (
                <Stack direction='row' alignItems='center' spacing={2}>
                  <Typography marginBottom={0}>Абонемент:</Typography>
                  <Typography sx={styles.text} marginBottom={0}>
                    Немає
                  </Typography>
                </Stack>
              )
            }
            {/* {
              userSubscriptions ? (
                <>
                  {
                    userSubscriptions?.map((s, index) => (
                      <Stack direction='row' alignItems='center' spacing={2}>
                        <Typography marginBottom={0}>Абонемент{userSubscriptions?.length > 1 ? ` ${index + 1}` : ""}:</Typography>
                        <Typography sx={styles.text} marginBottom={0}>
                          {s.name}
                        </Typography>
                      </Stack>
                    ))
                  }
                </>
              ) : (
                <Stack direction='row' alignItems='center' spacing={2}>
                  <Typography marginBottom={0}>Абонемент:</Typography>
                  <Typography sx={styles.text} marginBottom={0}>
                    Немає
                  </Typography>
                </Stack>
              )
            } */}
            {contract?._refunded ? (
              <Typography color={"secondary"} fontWeight={'500'} variant='h6' fontSize={14} style={{ marginTop: 0 }}>Кошти за поїздку було повернуто</Typography>
            ) : null}
          </Stack>

          {
            (cost || userSubscriptions) && contract?._id ? <UserRefund contractId={contract?._id} max={cost as number} userSubscription={userSubscriptions} onSave={() => props.onClose?.({}, 'backdropClick')} /> : null
          }
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.onClose?.({}, 'backdropClick')}>
          Вихід
        </Button>
      </DialogActions>
    </Dialog>
  );
};
